import React, { Component } from 'react';
import PropTypes from 'prop-types';

import NameableQualityComponent from './NameableQualityComponent';

export default class NameableQualityContainer extends Component {
  /**
   * Render
   * @return {Object}
   */
  render() {
    const {
      branchId,
      qualityName,
      qualityPossessedId,
    } = this.props;

    return (
      <NameableQualityComponent
        branchId={branchId}
        qualityName={qualityName}
        qualityPossessedId={qualityPossessedId}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

NameableQualityContainer.propTypes = {
  branchId: PropTypes.number.isRequired,
  qualityName: PropTypes.string.isRequired,
  qualityPossessedId: PropTypes.number.isRequired,
};